export default __webpack_public_path__ + "static/media/Engel-über-Wolken.fb856920.webp";